import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { SurveyRuntimeApiProvider } from './context/SurveyRuntimeApiContext';
import { SurveyRuntimeAuthProvider } from './context/SurveyRuntimeAuthContext';
import './styles/surveyModule.css';

/**
 * Survey Runtime UI region: scoped CSS tokens + shared runtime API + /me auth.
 */
export default function SurveyModuleLayout() {
  return (
    <SurveyRuntimeApiProvider>
      <SurveyRuntimeAuthProvider>
        <Box className="survey-module" sx={{ p: { xs: 1.5, sm: 2 }, maxWidth: '100%' }}>
          <Outlet />
        </Box>
      </SurveyRuntimeAuthProvider>
    </SurveyRuntimeApiProvider>
  );
}
